//import { createPopper } from '@popperjs/core';
require('./bootstrap');


/**
 * Frontend Website
 */

const sliderIndexes = [];
const slideCounts = [];
const sliderIntervals = [];
const sliderLastSwitched = [];

const timerDuration = 6000;

// Slider
$(document).ready(() => {
    $('#navbarSupportedContent').on('show.bs.collapse', function () {
        $('body').addClass('no-scroll-mobile');
    })
    $('#navbarSupportedContent').on('hidden.bs.collapse', function () {
        $('body').removeClass('no-scroll-mobile');
    })

    // Loop through all sliders
    $('.js-slider').each(function (index) {
        $(this).css('opacity', '1');
        // Start the slider at first index
        sliderIndexes[index] = 0;
        const slider = this;

        // Get slider variables
        const noOfSlides = $(this).find('.js-slide').length;
        slideCounts[index] = noOfSlides;

        const indicators = $(this).find('.js-slide-indicators');

        // Loop through slides
        for (let i = 0; i < noOfSlides; i++) {
            // Create indicator for slide
            const indicator = document.createElement("div");
            indicator.className = "js-slide-indicator";
            $(indicator).appendTo(indicators);
        }

        $(slider).find('.js-slide').each(function (index) {
            $(this).fadeOut(10);
            if (index == 0) {
                const firstSlide = this;

                $(firstSlide).find('img').first().on('load', function () {
                    $(slider).height(($(firstSlide).height() * getHeightCoefficient()) + 'px');
                });
            }
        });

        // Bind each indicator to changing the slide
        $(this).find('.js-slide-indicator').each(function (indicatorIndex) {
            // Change slide to index when clicked
            $(this).on('click', function () {
                sliderIndexes[index] = indicatorIndex;
                startSlider(slider, index);
            });
        });

        // Start the slider
        startSlider(slider, index);
    });

    // Reshow all sliders on window change
    $(window).resize(() => {
        $('.js-slider').each(function (index) {
            startSlider(this, index);
        });
    });
});


// Start the slider
function startSlider(slider, index) {
    clearInterval(sliderIntervals[index]);

    showSlide(slider, index);

    sliderIntervals[index] = intervalSlide(slider, index);
}

// Change slide on a interval
function intervalSlide(slider, index) {
    // Set to zero to always show
    sliderLastSwitched[index] = 0;

    return setInterval(() => {
        const currentDate = (new Date()).valueOf();
        const expectedFrame = sliderLastSwitched[index] + timerDuration;

        // If the time is within 100ms of the expected frame
        console.log(currentDate - expectedFrame);
        if (currentDate - expectedFrame > -100) {
            sliderLastSwitched[index] = currentDate;
            // Find the new index
            let newIndex = sliderIndexes[index] + 1;
            if (newIndex >= slideCounts[index]) {
                newIndex = 0;
            }

            sliderIndexes[index] = newIndex;
            showSlide(slider, index);
        }

    }, timerDuration)
}


// Get the current data and show the slides given
function showSlide(slider, index) {
    // Slide transition duration
    const duration = 500;
    // Fade in the correct slide
    $(slider).find('.js-slide').each(function (slideIndex) {
        if (sliderIndexes[index] == slideIndex) {
            $(this).fadeIn(duration);

            // Change slider height to match new slide
            $(slider).height(($(this).height() * getHeightCoefficient()) + 'px');
        } else {
            $(this).fadeOut(duration);
        }
    });


    // Change indicators to represent correct slide
    $(slider).find('.js-slide-indicator').each(function (indicatorIndex) {
        if (sliderIndexes[index] == indicatorIndex) {
            $(this).addClass('active');
        } else {
            $(this).removeClass('active');
        }
    });
}

function getHeightCoefficient(height) {
    return $(window).width() < 768 ? 1 : 0.97;
}


// Select Overwrite Code
// https://jsfiddle.net/BB3JK/47/

$(document).ready(() => {
    // Iterate over each select element
    $('select').each(function () {

        // Cache the number of options
        var $this = $(this),
            numberOfOptions = $(this).children('option').length;

        // Hides the select element
        $this.addClass('s-hidden');

        // Wrap the select element in a div
        $this.wrap('<div class="select"></div>');

        // Insert a styled div to sit over the top of the hidden select element
        $this.after('<div class="styledSelect form-control"></div>');

        // Cache the styled div
        var $styledSelect = $this.next('div.styledSelect');
        $styledSelect.attr('tabIndex', 0);

        // Show the currently selected option (not always the first)
        var $selectedOption = $this.find('option:selected');
        if (!$selectedOption.length) {
            $selectedOption = $this.children('option').eq(0);
        }
        $styledSelect.text($selectedOption.text());

        // Insert an unordered list after the styled div and also cache the list
        var $list = $('<ul />', {
            'class': 'options'
        }).insertAfter($styledSelect);

        // Insert a list item into the unordered list for each select option
        for (var i = 0; i < numberOfOptions; i++) {
            $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
            }).appendTo($list);
        }

        // Cache the list items
        var $listItems = $list.children('li');

        // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
        const openSelect = function (e) {
            e.stopPropagation();
            $('div.styledSelect.active').each(function () {
                $(this).removeClass('active').next('ul.options').hide();
            });
            $(this).toggleClass('active').next('ul.options').toggle();
        }
        $styledSelect.click(openSelect);
        $styledSelect.focus(openSelect);

        // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
        // Updates the select element to have the value of the equivalent option
        $listItems.mousedown(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
            /* alert($this.val()); Uncomment this for demonstration! */
        });

        // Hides the unordered list when clicking outside of it
        $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
        });
        $styledSelect.focusout(function () {
            $styledSelect.removeClass('active');
            $list.hide();
        });

    });
});